import loggingService from '../util/loggingService'

var serviceName = 'featureService'
var path = '/Lookup/Feature/'
var isDebug = false

function listFeature (http) {
    loggingService.log(isDebug, serviceName, 'listFeature')

    return http.get(path + 'ListFeature')
}

export default {
    listFeature: listFeature
}



// WEBPACK FOOTER //
// ./src/services/lookup/featureService.js